import { mapState, mapActions } from "pinia";
import { useUserStore } from "@/store/user";
import useVuelidate from "@vuelidate/core";
import { useAuthStore } from "@/store/auth";

export default {
  data() {
    return {
      v$: null,
    };
  },

  methods: {
    ...mapActions(useUserStore, ["getEditData", "clearEditData"]),
    ...mapActions(useAuthStore, [
      "setErrorMessage",
      "clearErrorMessage",
      "startLoading",
      "stopLoading",
    ]),

    fetch() {
      this.getEditData();
    },

    async save(id = null, data, api, redirect = null) {
      this.startLoading();
      let response;

      if (id) {
        response = await api(id, data);
      } else {
        response = await api(data);
      }

      if (response.success || response.status) {
        this.showNotification(response.message, "success");
        this.clearErrorMessage();
        this.clearEditData();
        if (redirect !== null) this.redirect(redirect);
      } else {
        this.setErrorMessage(response.message, "danger");
        this.showNotification(response.message, "error");
      }

      this.stopLoading();
      return response
    },

    showNotification(message, type) {
      this.$refs.toast.showToast(message, type);
    },

    redirect(redirect) {
      setTimeout(() => {
        this.$router.push(redirect);
      }, 2000);
    },
  },

  computed: {
    ...mapState(useUserStore, ["userEditData"]),
    ...mapState(useAuthStore, ["loading", "msgTxt", "msgType", "ldata"]),
  },

  mounted() {
    this.fetch();
  },

  created() {
    this.v$ = useVuelidate(this.$options.validations, this);
  },
};
